import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import gatewayReducer from './gateway/gatewaySlice'
import payloadReducer from './payload/payloadSlice'

export const store = configureStore({
  reducer: {
    gateway: gatewayReducer,
    payload: payloadReducer
  },
  devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
export * from './gateway/gatewaySlice'
export * from './payload/payloadSlice'
